.imageBacking {
  /* The scan surface, not the surrounding tool, must remain light. */
  background: var(--mtds-color-surface-default);
}

.image {
  display: block;
  max-width: 100%;
  height: auto;
}
